<div class="spinner-container" >
    <mat-spinner></mat-spinner>
    <div class="spinner-text">Aguarde mientras estamos procesando su solicitud.</div>
</div>


